import { useState } from "react";
import { useApi, createAPIPOSTPayload } from "../auth";
import { backend_url } from "../constants";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

export default function NameEdit({ initialName, uuid }) {
  const [name, setName] = useState(initialName);
  const [isEditing, setIsEditing] = useState(false);
  const { apiFetch } = useApi();
  function saveName() {
    const settings = {
      name: name
    };
    const payload = createAPIPOSTPayload(settings);
    apiFetch(backend_url + "/api/update-run-name/" + uuid + "/", payload).then((res) =>{
      if(res.status==200){
        console.log("name updated")
      }
      else{
        res.json().then(json=>console.log(json));
        
      }
    }
    );
  }
  if (isEditing) {
    return (
      <div className="name-edit">
        <Form>
          <Form.Control
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Form>
        <Button
            className="dt-button"
            variant="primary"
            type="submit"
            style={{ marginLeft: "5px" }}
            onClick={(e) => {
              e.preventDefault();
              saveName();
              setIsEditing(false);
            }}
          >
            Done
          </Button>
      </div>
    );
  } else {
    return (
      <div className="name-edit">
        <h4>{name}</h4>
        <span
          style={{
            cursor: "pointer",
            margin: "3px",
            fontVariationSettings: "'FILL' 1, 'wght' 300, 'GRAD' 0, 'opsz' 24",
          }}
          className="material-symbols-rounded"
          onClick={() => setIsEditing(true)}
        >
          edit
        </span>
      </div>
    );
  }
}
